import * as React from "react";
import { useWallet } from "@tronweb3/tronwallet-adapter-react-hooks";
import Button from "antd/es/button";
import Image from "antd/es/image";
import message from "antd/es/message";
import { ButtonProps, WalletActionButton, WalletModalProvider } from "@tronweb3/tronwallet-adapter-react-ui";
import { toUnits } from "thirdweb";
import Flex from "antd/es/flex";
import { FormModel } from "./types";
import settings from "../settings.json";
import { decimals } from "./constants";
import { truncate } from "./utils";
import { useVerifyReserves } from "./useVerifyReserves";

export interface TronPaymentButtonProps {
    formModel: FormModel;
    setTransactionId: (txId: string) => void;
}

export const TronPaymentButton: React.FunctionComponent<TronPaymentButtonProps> = (props) => {
    const { address, connected, signTransaction } = useWallet();
    const canPay = address && connected && window.tronWeb;
    const [loading, setLoading] = React.useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const verify = useVerifyReserves();

    const sendPayment = async () => {
        if (window.tronWeb && canPay) {
            try {
                setLoading(true);
                const recipient = settings.seller.trx;
                const amount = toUnits(props.formModel.fromAmount, decimals.Tron[props.formModel.token]);
                const unsignedTx = await window.tronWeb.transactionBuilder.triggerSmartContract(
                    props.formModel.token === "LLD" ? settings.lld.trx : settings.usdt.trx,
                    "transfer(address,uint256)",
                    {},
                    [
                        { type: "address", value: recipient },
                        { type: "uint256", value: amount.toString() }
                    ],
                    address
                );
                const signedTx = await signTransaction(unsignedTx.transaction);
                const verified = await verify.mutateAsync(props.formModel);
                if (!verified) {
                    messageApi.error("Not enough reserves, try again later");
                } else {
                    const transaction = await window.tronWeb.trx.sendRawTransaction(signedTx);
                    props.setTransactionId(transaction.txid);
                }
            } catch (err) {
                console.error(err);
                messageApi.error("Transaction failed");
            } finally {
                setLoading(false);
            }
        }
    };
    const buttonProps: ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement> = {
        type: "button",
        className: "TronButton TronButton--payment",
        disabled: loading,
        icon: require("../tron.svg").default,
    };

    return (
        <Flex wrap gap="15px" justify="center" align="center" flex={1} className="TronwebModal TronwebModal--payment">
            {canPay && (
                <Button
                    icon={<Image src={require("../tron.svg").default} width="22px" height="22px" preview={false} />}
                    className="TronButton TronButton--payment TronButton--main"
                    loading={loading}
                    onClick={sendPayment}
                >
                    Pay
                </Button>
            )}
            <WalletModalProvider>
                {contextHolder}
                <WalletActionButton {...buttonProps}>
                    {canPay ? `Connected: ${truncate(address, 3)}` : "Connect"}
                </WalletActionButton>
            </WalletModalProvider>
        </Flex>
    );
};
